import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SapMaterialGroupService } from '../proxy/controlling/controllers/sap-material-group.service';

FieldBuilder.setNamespace('Controlling');

export const SAPMATERIAL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.SapMaterial.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('description', 'Entity.SapMaterial.Description')
    .maxLength(100)
    .build(),
  FieldBuilder.foreignKey(
    'sapMaterialGroupId',
    'Entity.SapMaterialGroup',
    SapMaterialGroupService
  )
    .required()
    .displayFromNested('sapMaterialGroup.name')
    .sortBy('sapMaterialGroup.name')
    .build(),
];

export const SAPMATERIAL_CONFIG = {
  entityName: 'SapMaterial',
  localizationKey: 'Controlling::Entity.SapMaterial',
  fields: SAPMATERIAL_FIELDS,
  permission: 'ControllingSap.SapMaterials',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
